<template>
    <div>
        <DFormRow
            :label="__('products.productPrices.form.notice_period')"
            :is-required="true"
            :error="errors.notice_period"
        >
            <DInput
                :id="`notice_period${idSuffix}`"
                :model-value="noticePeriod"
                type="number"
                min="0"
                max="127"
                @update:modelValue="$emit('update:noticePeriod', $event)"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.notice_period_unit')"
            :is-required="true"
            :error="errors.notice_period_unit"
        >
            <DSelect
                :id="`notice_period_unit${idSuffix}`"
                :model-value="noticePeriodUnit"
                :options="unitOptions"
                @update:modelValue="$emit('update:noticePeriodUnit', $event)"
            />
        </DFormRow>
    </div>
</template>

<script>
export default {
    name: 'NoticePeriod',
    props: {
        noticePeriod: {
            type: [String, Number],
            default: null
        },
        noticePeriodUnit: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        idSuffix: {
            type: String,
            default: ''
        }
    },
    emits: ['update:noticePeriod', 'update:noticePeriodUnit'],
    computed: {
        unitOptions () {
            return [{ label: '', value: '' }, ...this.contractTermUnits]
        }
    }
}
</script>
